/**
 * The note every reasoned write on this screen asks for.
 *
 * Three routes take the same shape — game status, provider status and
 * per-brand availability — and all three declare the same bounds in
 * `packages/contracts/src/lists.ts`. They live here once so the form cannot
 * drift from the route that refuses it, and so a change to the contract has
 * one place to land rather than three.
 */
export const NOTE_MIN = 10;
export const NOTE_MAX = 500;

export function noteError(note: string, touched: boolean): string | undefined {
  if (!touched) return undefined;
  if (note.trim().length < NOTE_MIN)
    return `At least ${NOTE_MIN} characters. This is what an operator reads six months from now.`;
  return undefined;
}

/** Trimmed on both sides of the wire: what the form accepts, the route accepts. */
export const noteIsValid = (note: string): boolean =>
  note.trim().length >= NOTE_MIN && note.trim().length <= NOTE_MAX;
